<script setup lang="ts">
/* COMPONENTS */
import BrandingLoader from "@/components/af/Loaders/BrandingLoader.vue"

/* STORES */
import { useUserStore } from "@/stores/user"
import { storeToRefs } from "pinia"

export interface Props {
  full?: boolean
}

withDefaults(defineProps<Props>(), {
  full: false,
})

const userStore = useUserStore()
const { isResellerAcc, user } = storeToRefs(userStore)
</script>

<template>
  <div
    id="appLoading"
    role="status"
    :aria-label="$t('accessibility.loading')"
    :class="[
      'relative flex h-full w-full items-center justify-center',
      full && 'fixed inset-0 z-9999 h-screen w-screen bg-white',
    ]"
  >
    <BrandingLoader v-if="user" :isDefault="!isResellerAcc" />
  </div>
</template>
